import React from 'react';
import {
  Box,
} from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Pagination, PaginationItem } from '@material-ui/lab';
import { SearchII } from '../../../../interfaces/servico';

interface Props {
  getSearch: (page: number) => void;
  listSearch?: SearchII;
}

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 62,
    marginBottom: 100,
    borderRadius: '50%',
    color: '#fff',
    '& .Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: '50%',
    },
  },
  paginationItem: {
    color: '#9E9E9E',
  },
  paginationSelected: {
    color: theme.palette.text.primary,
  },
}));

export default function PaginationService({
  getSearch,
  listSearch,
}: Props): JSX.Element {
  const classes = useStyles();
  return (
    <Box className={classes.main}>
      <Pagination
        renderItem={(item) => (
          <PaginationItem
            {...item}
            classes={{ root: classes.paginationItem, selected: classes.paginationSelected }}
          />
        )}
        // count={listSearch.total_pages}
        // page={listSearch.current}
        onChange={(e, page) => getSearch(page)}
      />
    </Box>
  );
}
